import { Flex, Icon, Link, Spacer, Text } from '@chakra-ui/react';
import { InMobile } from '@ui/components/MobileOrDesktop';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';
import { ColorThemeVars } from '@veno-app/chakra';
import { Discord, Telegram, Twitter } from '@veno-app/icons';
import React from 'react';

function GardenViewHelpersPrelaunch() {
  return (
    <>
      <InMobile>
        <Text mx="auto" maxW="340px" textStyle="bodySmall" textAlign="center">
          Grow your Garden by watering and employing helpers to increase your
          harvest, earning you more rewards.
        </Text>
      </InMobile>
      <Spacer mt={4} />
      {/* <Flex justify="center" mb={6}>
        <Link isExternal href={EXTERNAL_LINK.mintedCruiserCollectionProd}>
          <Image
            w="150px"
            h="150px"
            src="/images/cruiser-planet.png"
            alt="Cronos Cruisers Collection"
          />
        </Link>
      </Flex> */}
      <Text mx="auto" maxW="340px" textStyle="h4" textAlign="center">
        The helpers are on their way. Stay up to date to learn when they arrive.
      </Text>
      <Spacer mt={8} />
      <Flex
        color="text.active"
        mt={6}
        flexDir={{
          base: 'column',
          desktop: 'row',
        }}
        align="center"
        justify="center"
        gap={6}
      >
        <Flex gap={6}>
          <Link
            isExternal
            textStyle="captionSmall"
            fontWeight="normal"
            fontSize="10px"
            href={EXTERNAL_LINK.twitter}
          >
            <Flex
              rounded="5px"
              boxShadow={`var(${ColorThemeVars.parentSmallShadow})`}
              py={3}
              align="center"
              flexDir="column"
              w="80px"
            >
              <Icon w="16px" h="16px" mb={1} as={Twitter} />
              Twitter
            </Flex>
          </Link>
          <Link
            isExternal
            textStyle="captionSmall"
            fontWeight="normal"
            fontSize="10px"
            href={EXTERNAL_LINK.discord}
          >
            <Flex
              rounded="5px"
              boxShadow={`var(${ColorThemeVars.parentSmallShadow})`}
              py={3}
              align="center"
              flexDir="column"
              w="80px"
            >
              <Icon w="16px" h="16px" mb={1} as={Discord} />
              Discord
            </Flex>
          </Link>
        </Flex>
        <Flex gap={6}>
          <Link
            isExternal
            textStyle="captionSmall"
            fontWeight="normal"
            fontSize="10px"
            href={EXTERNAL_LINK.telegramAnnouncements}
          >
            <Flex
              rounded="5px"
              boxShadow={`var(${ColorThemeVars.parentSmallShadow})`}
              py={3}
              align="center"
              flexDir="column"
              w="80px"
            >
              <Icon w="16px" h="16px" mb={1} as={Telegram} />
              Announcements
            </Flex>
          </Link>
        </Flex>
      </Flex>
    </>
  );
}

export default GardenViewHelpersPrelaunch;
